import React from 'react';
import { useSelector } from 'react-redux';
import Bar from './barPop';

export default function ContenPop() {
  const incomeGroups = useSelector((state) => state.data.incomeGroups);

  function getIncomeGroups() {
    if (incomeGroups.length > 0) {
      return (
        <div className="table-section">
          <h3>Total population by vaccine status (billions)</h3>
          <div className="data-wrap">
            <div className="numbers-wrap">
              <div className="num0">0</div>
              <div className="num50">1.5b</div>
              <div className="num100">3b</div>
            </div>
            <div className="lines-wrap">
              <div className="line0" />
              <div className="line25" />
              <div className="line50" />
              <div className="line75" />
              <div className="line100" />
            </div>
            {incomeGroups.map((obj, index) => {
              return <Bar key={obj.countryCount} index={index} {...obj} />;
            })}
          </div>
        </div>
      );
    }
    return <div />;
  }

  return <>{getIncomeGroups()}</>;
}
